import { render, staticRenderFns } from "./NewService.vue?vue&type=template&id=1393f184"
import script from "./NewService.vue?vue&type=script&lang=js"
export * from "./NewService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports